var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 951,
    height: 952,
    viewBox: "0 0 951 952",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.265 1H541.171V207.244V207.247L541.06 257.671C540.959 304.268 552.42 346.971 580.504 375.467L581.216 374.765L580.504 375.467C600.439 395.691 620.457 405.221 649.988 412.162C675.71 418.21 703.504 419.858 730.998 419.858H949.998V532.008H818.963L694.454 532.001C624.801 531.997 562.92 513.276 503.194 452.841C491.002 440.504 482.821 431.81 472.597 416.889L471.772 417.454L472.597 416.888C441.529 371.552 428.089 318.1 430.537 259.99L430.538 259.968L430.538 259.947L430.265 1Z",
    stroke: "#FE5840",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.279 431.765L262.281 431.765C338.951 431.589 404.179 457.462 450.267 503.188C496.354 548.912 523.375 614.56 523.497 694.071L522.916 950.372H416.397V707.994C416.397 675.483 412.728 642.755 399.961 615.365C385.76 584.855 365.751 565.123 341.596 552.472C317.467 539.835 289.254 534.293 258.677 532.057L258.674 532.057C258.67 532.057 258.66 532.056 258.645 532.054C258.563 532.046 258.333 532.023 258.182 532.023L128.659 532.008H1V431.765L262.279 431.765Z",
    stroke: "#989D9F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M896.812 130.349L690.049 342.07L614.036 266.538L821.394 58.1285L896.812 130.349Z",
    stroke: "#FE5840",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M896.493 814.668L820.439 891.889L612.628 682.074L688.079 607.817L896.493 814.668Z",
    stroke: "#FE5840",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M337.892 689.794L138.822 890.721C137.831 890.084 136.308 888.897 134.32 887.207C131.89 885.143 128.847 882.4 125.389 879.18C118.474 872.742 109.923 864.421 101.329 855.853C84.7494 839.324 68.0874 821.953 62.7112 815.427L264.683 615.581L337.892 689.794Z",
    stroke: "#989D9F",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M337.88 258.445L264.294 333.095L62.393 132.886L138.62 57.9127L337.88 258.445Z",
    stroke: "#FE5840",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.96374476b115f23b06ebcea3f06c544b.svg";
export { ForwardRef as ReactComponent };